export const ROLE_ID = 'ROLE_ID'

export const SESSION_USER = 'SESSION_USER'

export const BIODATA_USER = 'BIODATA_USER'

export const SET_API_TOKEN = 'SET_API_TOKEN'

export const SET_SESSION_ID = 'SET_SESSION_ID'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js